// extracted by mini-css-extract-plugin
export var panel = "panel-module--panel--1mqV6";
export var panel__header = "panel-module--panel__header--3nC-0";
export var panel__content = "panel-module--panel__content--1wS0b";
export var panel__innerpanel = "panel-module--panel__innerpanel--2etrY";
export var panel__footer = "panel-module--panel__footer--UjUZE";